// extracted by mini-css-extract-plugin
export default {"localeSwitch":"styles_localeSwitch__WutjB","localeSwitchActive":"styles_localeSwitchActive__hnce8"};